import { removeUserFromOffice } from "../api/userService";

export const useRemoveUserOffice = () => {
    const remove = async (userId, officeId) => {
    try {
        const response = await removeUserFromOffice(userId, officeId);
        const newRemoval = response;
        return newRemoval; // still return the created record
    } 
    catch (error) {
        console.error("Error removing user from office:", error);
        throw error;
    }
  };

  return { remove };
};